var _path, _mask, _g, _path2, _mask2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91699 23.0003C1.91699 34.6443 11.3563 44.0837 23.0003 44.0837C34.6443 44.0837 44.0837 34.6443 44.0837 23.0003C44.0837 11.3563 34.6443 1.91699 23.0003 1.91699C11.3563 1.91699 1.91699 11.3563 1.91699 23.0003ZM42 23C42 33.4934 33.4934 42 23 42C12.5066 42 4 33.4934 4 23C4 12.5066 12.5066 4 23 4C33.4934 4 42 12.5066 42 23Z",
    fill: "#A7A7A7"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 44,
    height: 44
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91699 23.0003C1.91699 34.6443 11.3563 44.0837 23.0003 44.0837C34.6443 44.0837 44.0837 34.6443 44.0837 23.0003C44.0837 11.3563 34.6443 1.91699 23.0003 1.91699C11.3563 1.91699 1.91699 11.3563 1.91699 23.0003ZM44 23C44 34.598 34.598 44 23 44C11.402 44 2 34.598 2 23C2 11.402 11.402 2 23 2C34.598 2 44 11.402 44 23Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "#A7A7A7"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4142 23L26.7071 17.7071C27.0976 17.3166 27.0976 16.6834 26.7071 16.2929C26.3166 15.9024 25.6834 15.9024 25.2929 16.2929L19.2929 22.2929C18.9024 22.6834 18.9024 23.3166 19.2929 23.7071L25.2929 29.7071C25.6834 30.0976 26.3166 30.0976 26.7071 29.7071C27.0976 29.3166 27.0976 28.6834 26.7071 28.2929L21.4142 23Z",
    fill: "#A7A7A7"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 16,
    width: 8,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4142 23L26.7071 17.7071C27.0976 17.3166 27.0976 16.6834 26.7071 16.2929C26.3166 15.9024 25.6834 15.9024 25.2929 16.2929L19.2929 22.2929C18.9024 22.6834 18.9024 23.3166 19.2929 23.7071L25.2929 29.7071C25.6834 30.0976 26.3166 30.0976 26.7071 29.7071C27.0976 29.3166 27.0976 28.6834 26.7071 28.2929L21.4142 23Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 24,
    height: 24,
    fill: "#A7A7A7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.06d9588682e1a10fa19bcee3224a4cc2.svg";
export { ForwardRef as ReactComponent };